import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { Context, Transitions } from "../types"
import { getServiceErrorMessage } from "../helpers"

export const buildPopulatedStudyPlanTranstition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  // TODO: pass backend the study plan if one exists (edit)
  invoke: {
    id: "buildPopulatedStudyPlan",
    src: "buildPopulatedStudyPlan",
    onDone: [
      {
        target: "edit_plan",
        actions: assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => {
          return {
            studyPlan: evt.data.plan,
            publishedStudyPlan: null,
            snackbar: {
              message: "Study plan has been generated"
            }
          }
        }),
        cond: ctx =>
          !ctx.isReadOnly &&
          (ctx.previousParentState === "edit_plan" ||
            ctx.currentTarget === "edit_plan") // currentTarget allows the user to go back to edit_plan using the back button
      },
      {
        target: "review_plan",
        actions: assign<Context, DoneInvokeEvent<any>>((_ctx, evt) => ({
          studyPlan: evt.data.plan,
          publishedStudyPlan: null
        }))
      }
    ],
    onError: {
      target: "#StudyPlan.study_plans_overview.idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage("newPlan", {
            errorReason: evt.data.message,
            messageData: ["create a new plan"]
          }),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
